import { Injectable, inject } from '@angular/core';
import { Language, ReactiveComponent, UserV2Service } from '@schenck/rotec-components';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class ServiceHelpDeskService extends ReactiveComponent {
  private readonly userService = inject(UserV2Service);

  private lang: Language = 'en';
  public helpDeskLanguageMapper = (lang: string) => {
    const mapper: Record<Language, string> = {
      de: 'https://schenck-rotec.de/services/hotline-helpdesk.html',
      en: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      es: 'https://www.schenck-rotec.es/servicios/servicio-de-ayuda.html',
      fr: 'https://www.schenck-rotec.fr/services/helpdesk.html',
      it: 'https://www.schenck-rotec.it/services/helpdesk.html',
      nl: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      pl: 'https://www.schenck-rotec.pl/serwis/helpdesk.html',
      sv: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      tr: 'https://www.schenck-rotec.com.tr/services/helpdesk.html',
      zh: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      cs: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      hu: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      ja: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      ko: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
      pt: 'https://schenck-rotec.com/services/hotline-helpdesk.html',
    };
    return mapper[lang];
  };

  constructor() {
    super();
    this.userService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe((user) => {
      this.lang = user.language;
    });
  }

  public addServiceRequest() {
    window.open(this.helpDeskLanguageMapper(this.lang), '_blank');
  }
}
